module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-900-583.41c75b1.woff2";